export const filterByVideoOptions = ( str, keys = false) => {
    const DESCR_STR = 'video.description:'
    const TITLE_STR = 'video.title:'
    let arr = str.split('; ')
    
    let options = arr.filter( it => ! it.includes( TITLE_STR ) && ! it.includes( DESCR_STR ) ).join('; '),
     title = (arr.find( it => it.includes( TITLE_STR ) ) ?? '').replace( TITLE_STR, '' ).replace(';', ''),
     description = (arr.find( it => it.includes( DESCR_STR ) ) ?? '').replace( DESCR_STR, '' ).replace(';', '')

    if( keys && title ) title = `data-title="${title}"`
    if( keys && description ) description = `data-description="${description}"`

    return [ title, description, options ]
}

